import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { localizedProperty } from '../utils'
import { paymentMethodLabels } from '../utils/purchases'

const UserSegmentEditor = ({
  title,
  segment = {},
  onSegmentChange,
  languages = [],
  countries = [],
  resorts = [],
  products = [],
  paymentMethods = [],
  resellers = [],
  regions = [],
  partners = [],
}) => {
  // segments management TODO
  // const { userSegments, userSegmentsLoaded, fetchUserSegments } = useContext(CustomersContext)
  // const { genericProducts, specificProducts, resorts } = useContext(ProductsContext)
  // const [selectedSegment, setSelectedSegment] = useState(null)

  // const [products, setProducts] = useState([])

  // useEffect(() => {
  //   // populate products list with generic and specific products tagged accordingly
  //   const allProducts = [
  //     ...genericProducts.map(product => ({ ...product, type: 'generic' })),
  //     ...specificProducts.map(product => ({ ...product, type: 'specific' })),
  //   ]
  //   setProducts(allProducts) 
  // })

  // segment properties
  const [product, setProduct] = useState(null)
  const [numberOfBeneficiaries, setNumberOfBeneficiaries] = useState({
    relation: 'moreThan',
    value: 0,
  })
  const [durationType, setDurationType] = useState(null) // days or season
  const [duration, setDuration] = useState({
    relation: 'moreThan',
    value: 0,
  })
  const [language, setLanguage] = useState(null)
  const [country, setCountry] = useState(null)
  // const [resort, setResort] = useState(null)
  const [segmentResorts, setSegmentResorts] = useState([])
  const [paymentMethod, setPaymentMethod] = useState(null)
  const [segmentResellers, setSegmentResellers] = useState([])
  const [segmentRegions, setSegmentRegions] = useState([])
  const [memberOfOrionTnNetwork, setMemberOfOrionTnNetwork] = useState(segment.memberOfOrionTnNetwork ?? null)
  const [orionTnOfficialDistributor, setOrionTnOfficialDistributor] = useState(segment.orionTnOfficialDistributor ?? null)
  const [orionTnOfficialLeadGenerator, setOrionTnOfficialLeadGenerator] = useState(segment.orionTnOfficialLeadGenerator ?? null)
  const [apiPurchase, setApiPurchase] = useState(null)
  const [apiPartner, setApiPartner] = useState(null)

  useEffect(() => {
    onSegmentChange({
      product,
      numberOfBeneficiaries,
      durationType,
      duration,
      language,
      country,
      // resort,
      resorts: segmentResorts,
      paymentMethod,
      resellers: segmentResellers,
      regions: segmentRegions,
      memberOfOrionTnNetwork,
      orionTnOfficialDistributor,
      orionTnOfficialLeadGenerator,
      apiPurchase,
      apiPartner,
    })
  }, [product, numberOfBeneficiaries, durationType, duration, language, country, segmentResorts, paymentMethod, segmentResellers, segmentRegions, memberOfOrionTnNetwork, orionTnOfficialDistributor, orionTnOfficialLeadGenerator, apiPurchase, apiPartner])

  useEffect(() => {
    if (segment) {
      if(segment.product !== product) {
        setProduct(segment.product || null)
      }
      if(segment.numberOfBeneficiaries && segment.numberOfBeneficiaries.relation !== numberOfBeneficiaries.relation) {
        setNumberOfBeneficiaries(segment.numberOfBeneficiaries || { relation: 'moreThan', value: 0 })
      }
      if(segment.durationType !== durationType) {
        setDurationType(segment.durationType || 'days')
      }
      if(segment.duration && segment.duration.relation !== duration.relation) {
        setDuration(segment.duration || { relation: 'moreThan', value: 0 })
      }
      if(segment.language !== language) {
        setLanguage(segment.language || null)
      }
      if(segment.country !== country) {
        setCountry(segment.country || null)
      }
      // if(segment.resort !== resort) {
      //   setResort(segment.resort || null)
      // }
      if(segment.resorts && JSON.stringify(segment.resorts) !== JSON.stringify(segmentResorts)) {
        setSegmentResorts(segment.resorts || [])
      }
      if(segment.paymentMethod !== paymentMethod) {
        setPaymentMethod(segment.paymentMethod || null)
      }
      if(segment.resellers && JSON.stringify(segment.resellers) !== JSON.stringify(segmentResellers)) {
        setSegmentResellers(segment.resellers || [])
      }
      if(segment.regions && JSON.stringify(segment.regions) !== JSON.stringify(segmentRegions)) {
        setSegmentRegions(segment.regions || [])
      }
      if(segment.memberOfOrionTnNetwork !== memberOfOrionTnNetwork) {
        setMemberOfOrionTnNetwork(segment.memberOfOrionTnNetwork ?? null)
      }
      if(segment.orionTnOfficialDistributor !== orionTnOfficialDistributor) {
        setOrionTnOfficialDistributor(segment.orionTnOfficialDistributor ?? null)
      }
      if(segment.orionTnOfficialLeadGenerator !== orionTnOfficialLeadGenerator) {
        setOrionTnOfficialLeadGenerator(segment.orionTnOfficialLeadGenerator ?? null)
      }
      if(segment.apiPurchase !== apiPurchase) {
        setApiPurchase(segment.apiPurchase ?? null)
      }
      if(segment.apiPartner !== apiPartner) {
        setApiPartner(segment.apiPartner ?? null)
      }
    }
  }, [segment])

  const getPartnerLabel = (partner) => {
    return partner?.name?.fr || partner?.name || partner?.company_name || partner?.title || partner?.id || 'N/A'
  }

  return (
    <div>
      <div className='d-flex align-items-center mb-3 justify-content-between'>
        <div className='fw-bold fs-6 mb-3'>{ title ?? 'User segment' }</div>
        {/* <button className='btn btn-primary'>Save Segment</button> */}
      </div>
      <div className='mb-3'>
        <label className='form-label'>Product</label>
        <select className={`form-select ${product ? 'form-select--filled' : ''}`}  value={product} onChange={(e) => setProduct(e.target.value)}>
          <option value=''>Any product</option>
          {products.map((prod) => (
            <option key={prod.id} value={prod.id}>
              {`${ localizedProperty(prod, 'name', 'fr')} (${prod.type})`}
            </option>
          ))}
        </select>
      </div>
      <div className='mb-3'>
        <label className='form-label'>Number of beneficiaries</label>
        <div className='d-flex align-items-center'>
          <select className={`form-select me-2 ${numberOfBeneficiaries.relation ? 'form-select--filled' : ''}`} value={numberOfBeneficiaries.relation} onChange={(e) => setNumberOfBeneficiaries({ ...numberOfBeneficiaries, relation: e.target.value })}>
            <option value='moreThan'>More than</option>
            <option value='lessThan'>Less than</option>
            <option value='exactly'>Exactly</option>
          </select>
          <input
            type='number'
            className='form-control'
            value={numberOfBeneficiaries.value}
            onChange={(e) => setNumberOfBeneficiaries({ ...numberOfBeneficiaries, value: parseInt(e.target.value) })}
            min='0'
            placeholder='0'
          />
        </div>
      </div>
      <div className='mb-3'>
        <label className='form-label'>Duration</label>
        <div className='d-flex align-items-center'>
          <select className={`form-select ${durationType ? 'form-select--filled' : ''} me-2`}  value={durationType} onChange={(e) => setDurationType(e.target.value)}>
            <option value=''>Any duration</option>
            <option value='days'>Days</option>
            <option value='season'>Season</option>
          </select>
          {durationType === 'days' && (
            <>
              <select className='form-select form-select--filled me-2' value={duration.relation} onChange={(e) => setDuration({ ...duration, relation: e.target.value })}>
                <option value='moreThan'>More than</option>
                <option value='lessThan'>Less than</option>
                <option value='exactly'>Exactly</option>
              </select>
              <input
                type='number'
                className='form-control'
                value={duration.value}
                onChange={(e) => setDuration({ ...duration, value: parseInt(e.target.value) })}
                min='0'
                placeholder='0'
              />
            </>
          )}
        </div>
      </div>
      <div className='mb-3'>
        <label className='form-label'>Language</label>
        <select className={`form-select ${language ? 'form-select--filled' : ''}`} value={language} onChange={(e) => setLanguage(e.target.value)}>
          <option value=''>Any language</option>
          {languages.map((lang) => (
            <option key={lang} value={lang}>
              {lang}
            </option>
          ))}
        </select>
      </div>
      <div className='mb-3'>
        <label className='form-label'>Country</label>
        <select className={`form-select ${country ? 'form-select--filled' : ''}`} value={country} onChange={(e) => setCountry(e.target.value)}>
          <option value=''>Any country</option>
          {countries.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      </div>
      <div className='mb-3'>
        <label className='form-label'>Resorts</label>
        <select className='form-select' value={segmentResorts} onChange={(e) => {
          const value = e.target.value
          setSegmentResorts((r) => {
            if(value) {
              r.push(value)
              return Array.from(new Set(r)) // Ensure unique values
            } else {
              return [] // Reset if no value selected
            }
          })
        }} placeholder='Add resort'>
          <option selected>{segmentResorts.length === 0 ? 'Any resort' : 'Add resort'}</option>
          {resorts.filter(r => !segmentResorts.includes(r.id)).toSorted((a, b) => {
            return localizedProperty(a, 'name', 'fr').localeCompare(localizedProperty(b, 'name', 'fr'))
          }).map((r) => (
            <option key={r.id} value={r.id} selected={false}>
              {localizedProperty(r, 'name', 'fr')}
            </option>
          ))}
        </select>
        <div className='mt-2 d-flex flex-row flex-wrap gap-2'>
          {segmentResorts.toSorted((a, b) => {
            return localizedProperty(a, 'name', 'fr').localeCompare(localizedProperty(b, 'name', 'fr'))
          }).map((resortId) => {
            const resort = resorts.find(r => r.id === resortId)
            return (
              <span key={resortId} className='badge rounded-pill bg-primary d-flex align-items-center'>
                {localizedProperty(resort, 'name', 'fr')}
                <button
                  type='button'
                  className='btn-close ms-2'
                  onClick={() => setSegmentResorts((prev) => prev.filter(id => id !== resortId))}
                />
              </span>
            )
          })}
        </div>
      </div>

      <div className='mb-3'>
        <label className='form-label'>Regions</label>
        <select className='form-select' value={segmentRegions} onChange={(e) => {
          const value = e.target.value
          setSegmentRegions((r) => {
            if(value) {
              r.push(value)
              return Array.from(new Set(r)) // Ensure unique values
            } else {
              return [] // Reset if no value selected
            }
          })
        }} placeholder='Add region'>
          <option selected>{segmentRegions.length === 0 ? 'Any region' : 'Add region'}</option>
          {regions.filter(r => !segmentRegions.includes(r.id)).toSorted((a, b) => {
            return localizedProperty(a, 'name', 'fr').localeCompare(localizedProperty(b, 'name', 'fr'))
          }).map((r) => (
            <option key={r.id} value={r.id} selected={false}>
              {localizedProperty(r, 'name', 'fr')}
            </option>
          ))}
        </select>
        <div className='mt-2 d-flex flex-row flex-wrap gap-2'>
          {segmentRegions.toSorted((a, b) => {
            return localizedProperty(a, 'name', 'fr').localeCompare(localizedProperty(b, 'name', 'fr'))
          }).map((regionId) => {
            const region = regions.find(r => r.id === regionId)
            return (
              <span key={regionId} className='badge rounded-pill bg-primary d-flex align-items-center'>
                {localizedProperty(region, 'name', 'fr')}
                <button
                  type='button'
                  className='btn-close ms-2'
                  onClick={() => setSegmentRegions((prev) => prev.filter(id => id !== regionId))}
                />
              </span>
            )
          })}
        </div>
      </div>

      <div className='mb-3'>
        <label className='form-label'>Networks</label>
        <select className='form-select' value={segmentResellers} onChange={(e) => {
          const value = e.target.value
          setSegmentResellers((r) => {
            if(value) {
              r.push(value)
              return Array.from(new Set(r)) // Ensure unique values
            } else {
              return [] // Reset if no value selected
            }
          })
        }} placeholder='Add network'>
          <option selected>{segmentResellers.length === 0 ? 'Any network' : 'Add network'}</option>
          {resellers.filter(r => !segmentResellers.includes(r.id)).toSorted((a, b) => {
            return localizedProperty(a, 'name', 'fr').localeCompare(localizedProperty(b, 'name', 'fr'))
          }).map((r) => (
            <option key={r.id} value={r.id} selected={false}>
              {r.company_name}
            </option>
          ))}
        </select>
        <div className='mt-2 d-flex flex-row flex-wrap gap-2'>
          {segmentResellers.toSorted((a, b) => {
            return localizedProperty(a, 'name', 'fr').localeCompare(localizedProperty(b, 'name', 'fr'))
          }).map((resellerId) => {
            const reseller = resellers.find(r => r.id === resellerId)
            return (
              <span key={resellerId} className='badge rounded-pill bg-primary d-flex align-items-center'>
                {reseller.company_name}
                <button
                  type='button'
                  className='btn-close ms-2'
                  onClick={() => setSegmentResellers((prev) => prev.filter(id => id !== resellerId))}
                />
              </span>
            )
          })}
        </div>
      </div>
      {[
        { key: 'memberOfOrionTnNetwork', label: 'Member of Orion TN network', value: memberOfOrionTnNetwork, onChange: setMemberOfOrionTnNetwork },
        { key: 'orionTnOfficialDistributor', label: 'Orion TN official distributor', value: orionTnOfficialDistributor, onChange: setOrionTnOfficialDistributor },
        { key: 'orionTnOfficialLeadGenerator', label: 'Orion TN official lead generator', value: orionTnOfficialLeadGenerator, onChange: setOrionTnOfficialLeadGenerator },
      ].map(({ key, label, value, onChange }) => (
        <div className='mb-3' key={key}>
          <label className='form-label' htmlFor={key}>{label}</label>
          <select
            id={key}
            className={`form-select ${value !== null ? 'form-select--filled' : ''}`}
            value={value === null ? '' : String(value)}
            onChange={(e) => onChange(e.target.value === '' ? null : e.target.value === 'true')}
          >
            <option value=''>Any</option>
            <option value='true'>Yes</option>
            <option value='false'>No</option>
          </select>
        </div>
      ))}
      <div className='mb-3'>
        <label className='form-label'>Payment Method</label>
        <select className={`form-select ${paymentMethod ? 'form-select--filled' : ''}`}  value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
          <option value=''>Any payment method</option>
          {paymentMethods.map((pm) => (
            <option key={pm} value={pm}>
              {paymentMethodLabels[pm] || pm}
            </option>
          ))}
        </select>
      </div>
      <div className='mb-3'>
        <label className='form-label'>API purchase</label>
        <select
          className={`form-select ${apiPurchase !== null ? 'form-select--filled' : ''}`}
          value={apiPurchase === null ? '' : apiPurchase ? 'true' : 'false'}
          onChange={(e) => {
            const value = e.target.value
            if(value === '') {
              setApiPurchase(null)
            } else {
              setApiPurchase(value === 'true')
            }
          }}
        >
          <option value=''>Any</option>
          <option value='true'>Yes</option>
          <option value='false'>No</option>
        </select>
      </div>
      <div className='mb-3'>
        <label className='form-label'>API partner</label>
        <select
          className={`form-select ${apiPartner ? 'form-select--filled' : ''}`}
          value={apiPartner || ''}
          onChange={(e) => setApiPartner(e.target.value || null)}
        >
          <option value=''>Any partner</option>
          {partners.map((partner) => (
            <option key={partner.id} value={partner.id}>
              {getPartnerLabel(partner)}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

UserSegmentEditor.propTypes = {
  title: PropTypes.string,
  segment: PropTypes.object,
  onSegmentChange: PropTypes.func,
  languages: PropTypes.arrayOf(PropTypes.string),
  countries: PropTypes.arrayOf(PropTypes.string),
  resorts: PropTypes.arrayOf(PropTypes.object),
  products: PropTypes.arrayOf(PropTypes.object),
  paymentMethods: PropTypes.arrayOf(PropTypes.string),
  resellers: PropTypes.arrayOf(PropTypes.object),
  regions: PropTypes.arrayOf(PropTypes.object),
  partners: PropTypes.arrayOf(PropTypes.object),
}

export default UserSegmentEditor
